import { createSlice } from "@reduxjs/toolkit";

const fileSlice = createSlice({
  name: "file",
  initialState: { file: "", files: {} },
  reducers: {
    // if there's no node in the payload, it will assume this is a single canvas product.
    saveFilePointer(state, action) {
      let { filePointer, node } = action.payload;
      if (node) {
        state.files = { ...state.files, [node]: filePointer };
      } else {
        state.file = filePointer;
      }
    },
    resetFiles(state, action) {
      let { data } = action.payload;
      state.files = data;
    },
  },
});

export const { saveFilePointer, resetFiles } = fileSlice.actions;
export default fileSlice.reducer;
